import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import {
  ButtonSize,
  ButtonState,
  ButtonType
} from '../../../../../../assets/types/dtoTypes';
import {
  IConsentPayload,
  RegistrationPageService
} from '../../registration-page.service';
import {ButtonComponent} from "../../../../../shared/button/button.component";

@Component({
  selector: 'app-consent-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ButtonComponent
  ],
  templateUrl: './consent-form.component.html',
  styleUrl: './consent-form.component.scss'
})
export class ConsentFormComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly registrationPageService = inject(RegistrationPageService);

  form!: FormGroup;

  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonState = ButtonState;
  protected readonly ButtonType = ButtonType;

  ngOnInit(): void {
    this.form = this.fb.group({
      privacy: new FormControl(false, [Validators.requiredTrue]),
      terms: new FormControl(false, [Validators.requiredTrue]),
      dataPrivacyConsent: new FormControl(false, [Validators.requiredTrue]),
      allConsents: new FormControl(false, [Validators.requiredTrue]),
    });
  }

  get isFormValid(): boolean {
    return this.form.valid;
  }

  goBack(): void {
    this.registrationPageService.openForm('consent_form_back');
  }

  continue(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const consents: IConsentPayload[] = [
      {
        type: 'PRIVACY',
        version: 'v1',
        accepted: this.form.get('privacy')?.value
      },
      {
        type: 'TERMS',
        version: 'v1',
        accepted: this.form.get('terms')?.value
      },
      {
        type: 'DATA_PRIVACY_CONSENT',
        version: 'v1',
        accepted: this.form.get('dataPrivacyConsent')?.value
      }
    ];

    this.registrationPageService.sendConsents(consents);
  }

  openPolicy(type: 'terms' | 'privacy' | 'data-consent' | 'cookie'): void {
    console.log('Open modal for:', type);
  }
}
